import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

/**
 * Composant d'autocomplétion réutilisable.
 *
 * Utilisation :
 * - `itemsInputAutoCompletion` contient la liste des suggestions à afficher.
 * - `inputValue` doit recevoir la valeur actuelle de l'input parent.
 * - `minItemsToDisplayAutocompletion` définit le nombre minimum de caractères
 *   à saisir avant d'afficher les suggestions.
 * - `customMessage` permet d'afficher un message sous la liste.
 * - `autocompletionSelected` émet la suggestion sélectionnée par l'utilisateur.
 *
 * Exemple :
 * <p-autocomplete
 *   [itemsInputAutoCompletion]="suggestions"
 *   [inputValue]="form.controls.myInput.value"
 *   [minItemsToDisplayAutocompletion]="3"
 *   [customMessage]="message"
 *   (autocompletionSelected)="onSuggestionSelected($event)"
 * ></p-autocomplete>
 */
@Component({
  selector: 'p-autocomplete',
  templateUrl: './p-autocomplete.component.html',
  styleUrls: ['./p-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PAutocompleteComponent implements OnChanges {
  ngOnChanges(): void {
    this.closeAutoCompletionOnSelect();
  }

  @Input() itemsInputAutoCompletion: string[] | undefined = [];
  @Input() minItemsToDisplayAutocompletion: number = 3;
  @Input() inputValue!: string | null;
  @Input() customMessage: string | undefined;

  @Output() autocompletionSelected = new EventEmitter<string>();

  inputLength: number | undefined;
  hasBeenClickedOn = false;
  autocompletionItemSelected = '';

  emitAutoCompletionItem(item: string) {
    this.autocompletionSelected.emit(item);
    this.autocompletionItemSelected = item;
    this.hasBeenClickedOn = true;
  }

  private closeAutoCompletionOnSelect() {
    if (
      this.inputValue !== this.autocompletionItemSelected &&
      this.hasBeenClickedOn
    ) {
      this.hasBeenClickedOn = false;
    }
  }
}
